import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { styled } from "@mui/material/styles";

const LocationReportPicker = ({
  setFieldValue,
  locationReportPage = false,
  isPartnerPowerUser = false,
  handleChange = () => {},
  locations,
  loading = false,
  location = {},
}) => {
  const SelectF = styled(Select)(() => ({
    width: "100%",
    fontSize: "15px",
  }));
  // eslint-disable-next-line no-unused-vars
  const getOptionStyle = (base, { isFocused, isSelected }) => ({
    ...base,
    fontSize: "15px",
    backgroundColor: isFocused ? "#DDEBFF" : "white",
    color: "black",
  });

  const modifiedOptions = isPartnerPowerUser
    ? [{ name: "All", value: "all" }, ...locations]
    : locations;

  return (
    <div>
      <SelectF
        onMenuOpen={document.body}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        closeMenuOnScroll={(e) => !e.target?.classList?.contains("select__menu-list")}
        className="basic-single"
        classNamePrefix="select"
        value={location?.name ? location : null}
        isLoading={loading}
        isClearable
        onChange={(option) => {
          if (option?.value === "all" && isPartnerPowerUser) {
            setFieldValue("all", true);
          } else {
            setFieldValue("all", false);
            setFieldValue("location", option || {});
          }

          handleChange(option);
        }}
        isSearchable
        getOptionValue={(option) => `${option.value}`}
        getOptionLabel={(option) => `${option.name}`}
        name="location"
        id="location"
        options={modifiedOptions}
        placeholder={locationReportPage ? "Select a Location" : "All"}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), option: getOptionStyle }}
      />
    </div>
  );
};

LocationReportPicker.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  locations: PropTypes.instanceOf(Array).isRequired,
  loading: PropTypes.bool,
  location: PropTypes.instanceOf(Object),
  locationReportPage: PropTypes.bool,
  isPartnerPowerUser: PropTypes.bool,
};

export default LocationReportPicker;
